import React from 'react';

import { Accordion } from '@gumtree/ui-library';

import { EXPANDED_FILTERS } from '../shared/constants';
import { Filter, FiltersDictionary, FilterKey } from '../../types';
import { RangedFreeform } from '../filters/range-freeform';
import { trackFilterOpenChange } from '../shared/filters-utils';
import { StyledRangeFilterFreeform } from './range-filter-freeform-frame.style';

export const RangeFilterFreeformFrame = ({
    filterKey,
    currentFilterStates,
    filtersDictionary,
}: {
    filtersDictionary: FiltersDictionary;
    filterKey: FilterKey;
    currentFilterStates: Filter;
}) => {
    const filtersDictionaryEntry = filtersDictionary[filterKey];
    const { minKey, maxKey, label } = filtersDictionaryEntry;

    if (!minKey || !maxKey) {
        return <></>;
    }

    const currentMinValue = currentFilterStates[minKey] as string | undefined;
    const currentMaxValue = currentFilterStates[maxKey] as string | undefined;

    return (
        <Accordion
            title={label}
            isDefaultOpened={EXPANDED_FILTERS.includes(filterKey)}
            onOpenChange={(open: boolean) => {
                trackFilterOpenChange(open, filterKey);
            }}
        >
            <StyledRangeFilterFreeform>
                <RangedFreeform
                    handleUpdateButtonClick={() => {}}
                    minKey={minKey}
                    maxKey={maxKey}
                    currentMinValue={currentMinValue}
                    currentMaxValue={currentMaxValue}
                    filterKey={filterKey}
                    isStateful
                />
            </StyledRangeFilterFreeform>
        </Accordion>
    );
};
